const Firebase = window?.['firebase']
import { firebaseConfig as firebaseConfigBase } from '../../../config'

export const initFirebase = () => {
    const firebaseConfig = {
        ...firebaseConfigBase
    }
    Firebase.initializeApp(firebaseConfig)
    Firebase.analytics()

    return firebaseConfig
}
